import React from 'react'
import { AppBar, Hidden, Toolbar, useMediaQuery } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton'
import UserMenu from 'app/fuse-layouts/shared-components/UserMenu'
import WarningEndPlan from 'app/components/WarningEndPlan'
import { useSelector } from 'react-redux'
import AppInfo from './AppInfo'
import clsx from 'clsx'
import * as R from 'ramda'
import { useTheme } from '@material-ui/core/styles'
import WarningPending from 'app/components/WarningPending'

const useStyles = makeStyles((theme) => ({
  separator: {
    width: 1,
    height: 64,
    backgroundColor: theme.palette.divider,
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
  },
}))

function ToolbarLayoutMain(props) {
  const config = useSelector(({ fuse }) => fuse.settings.current.layout.config)

  const classes = useStyles(props)
  const isShowAppInfo = R.includes(process.env['REACT_APP_ENV'], ['dev', 'qa'])

  //Responsive
  const theme = useTheme()
  const isDownXs = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <AppBar
      id="fuse-toolbar"
      elevation={2}
      className={clsx(classes.appBar, 'flex relative')}
      color="default"
    >
      <Toolbar className="p-0">
        {config.navbar.display && config.navbar.position === 'left' && (
          <Hidden lgUp>
            <NavbarMobileToggleButton className="w-64 h-64 p-0" />
            <div className={classes.separator} />
          </Hidden>
        )}

        <div className="flex flex-1 justify-end lg:justify-between ltr:pr-4 rtl:pl-4">
          <div className="hidden lg:flex">
            <WarningEndPlan {...props} />
          </div>
          <div className="hidden lg:flex">
            <WarningPending {...props} />
          </div>
          <div className="flex">
            {!isDownXs && isShowAppInfo && <AppInfo />}
            <UserMenu />
          </div>
        </div>
      </Toolbar>
    </AppBar>
  )
}

export default ToolbarLayoutMain
